import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import {
  Tabs,
  Tab,
} from 'react-bootstrap';
import './CreateSelectModal.scss';

const CreateSelectModal = ({
  title,
  selectView,
  createView,
  isShown,
  onRequestClose,
}) => (
  <div className="create-select-modal">
    <Modal isOpen={isShown} toggle={onRequestClose} size="lg">
      <ModalHeader toggle={onRequestClose}>
        {title}
      </ModalHeader>
      <ModalBody>
        <div>
          <Tabs fill>
            <Tab className="pt-3" title="Create New Record" eventKey="create-select-create-view">{createView}</Tab>
            <Tab className="pt-3" title="Select Existing Record" eventKey="create-select-select-view">{selectView}</Tab>
          </Tabs>
        </div>
      </ModalBody>
    </Modal>
  </div>
);

CreateSelectModal.propTypes = {
  title: PropTypes.string,
  selectView: PropTypes.node,
  createView: PropTypes.node,
  isShown: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

CreateSelectModal.defaultProps = {
  title: undefined,
  selectView: undefined,
  createView: undefined,
};

export default CreateSelectModal;
